import { useCallback, useEffect } from 'react';

const useWindowScrollPosition = (onScroll: (scrollPosition: { scrollX: number; scrollY: number }) => void) => {
  const getScrollPosition = useCallback(
    () => ({
      scrollX: window.pageXOffset || document.documentElement.scrollLeft,
      scrollY: window.pageYOffset || document.documentElement.scrollTop
    }),
    []
  );
  useEffect(() => {
    let request: number;

    const handleScroll = () => {
      cancelAnimationFrame(request);
      request = requestAnimationFrame(() => onScroll(getScrollPosition()));
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(request);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getScrollPosition]);
};

export default useWindowScrollPosition;
